import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { operations } from 'state/ducks/map';
import { bool, func, string } from 'prop-types';

import styles from './Settings.scss';

export function Settings({ setViewMode, viewMode, isMapPanelOpen }) {
  return (
    <div>
      <form className={styles.main}>
        <fieldset>
          <div className={styles.fieldsetContent}>
            <legend>Map view</legend>
            <div className={styles.radioInput}>
              <input
                id="segments"
                type="radio"
                name="segments"
                value="segments"
                tabIndex={isMapPanelOpen ? -1 : 0}
                checked={viewMode === 'segments'}
                onChange={() => setViewMode('segments')}
              />
              <label htmlFor="segments">Segments</label>
            </div>
            <div className={styles.radioInput}>
              <input
                id="routes"
                type="radio"
                name="routes"
                value="routes"
                tabIndex={isMapPanelOpen ? -1 : 0}
                checked={viewMode === 'routes'}
                onChange={() => setViewMode('routes')}
              />
              <label htmlFor="routes">Routes</label>
            </div>
          </div>
        </fieldset>
      </form>
      <ul className={styles.createLinks}>
        <h3>Edit map</h3>
        <li>
          <Link className={styles.createLink} to="/map/create/segment">
            <span>+</span> Add segments
          </Link>
        </li>
        <li>
          <Link className={styles.createLink} to="/map/create/route">
            <span>+</span> Add routes
          </Link>
        </li>
      </ul>
    </div>
  );
}

Settings.propTypes = {
  setViewMode: func.isRequired,
  isMapPanelOpen: bool,
  viewMode: string,
};

const mapStateToProps = ({ map }) => ({
  isMapPanelOpen: map.isMapPanelOpen,
  viewMode: map.viewMode,
});

const ConnectedSettings = connect(mapStateToProps, operations)(Settings);

export default ConnectedSettings;



// WEBPACK FOOTER //
// ./src/components/MapPanel/Settings/index.js